import { useMemo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Keyboard, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';

import NewsCardV2 from '../NewsCardV2';

export function NewsCarouselV2({
	items = [],
	className = '',
	autoPlay = false,
	autoPlayMs = 5000,
}) {
	const modules = useMemo(
		() => [Pagination, Keyboard, ...(autoPlay ? [Autoplay] : [])],
		[autoPlay],
	);

	if (!items?.length) return null;

	const isSingle = items.length === 1;

	return (
		<div className={['w-full swiper-carousel-news', className].join(' ')}>
			<Swiper
				modules={modules}
				slidesPerView={1.1}
				spaceBetween={32}
				centeredSlides={isSingle}
				centeredSlidesBounds={isSingle}
				pagination={{ clickable: true }}
				keyboard={{ enabled: true }}
				autoplay={
					autoPlay ? { delay: autoPlayMs, disableOnInteraction: false } : false
				}
				breakpoints={{
					0: { slidesPerView: 1.1, spaceBetween: 16 },
					768: { slidesPerView: 1.5, spaceBetween: 24 },
					1024: { slidesPerView: 2.5, spaceBetween: 28 },
					1280: { slidesPerView: 3.5, spaceBetween: 32 },
				}}
				className='!pb-10'
			>
				{items.map((item, i) => (
					<SwiperSlide
						key={item.id ?? i}
						className={['!h-auto', isSingle ? '!w-full' : ''].join(' ')}
					>
						{/* Center the fixed-width card inside the slide */}
						<div className={isSingle ? 'flex w-full justify-center' : 'flex'}>
							<NewsCardV2
								imageUrl={item.image_url}
								title={item.title}
								description={item.description}
								category={item.category}
								content={item.rich_text}
								badgeText='New'
							/>
						</div>
					</SwiperSlide>
				))}
			</Swiper>

			<style jsx global>{`
				.swiper-pagination-bullet {
					opacity: 1;
					background: #d9d9d9;
				}
				.swiper-pagination-bullet-active {
					background: black;
					// transform: scale(1.05);
				}
				.swiper-carousel-news,
				.swiper-carousel-news * {
					animation: none !important;
					animation-name: none !important;
					animation-duration: 0s !important;
				}
			`}</style>
		</div>
	);
}
